// A wrapper around axios
import axios from 'axios';

const api = axios.create({
  baseURL: '/',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getProducts = (lang) => {
  return api.get(`${lang}/products/data`);
};

export const getMapDetails = (lang, id) => {
  return api.get(`${lang}api/map/${id}`);
};

export const getDownloadsData = (lang) => {
  return api.get(`${lang}api/get/downloadsData`);
};

export const getHeroSlides = (lang) => {
  return api.get(`${lang}api/frontend/headline`);
};

export const getSalesContacts = (lang) => {
  return api.get(`${lang}api/get/allSalesContacts`);
};

export const getSearchResults = (lang, term) => {
  // don't try to get data if term is null/undefined
  // happens when you add focus to the search input field
  if (term == null) return;
  return api.get(`${lang}api/get/searchData?search=${term}`);
};

export const getSocialMediaPosts = (lang) => {
  return api.get(`${lang}api/get/socialTimeline`);
};

export const getApplicationRecommendations = (lang, id) => {
  return api.get(`${lang}api/get/productApplicationRecommendationData/${id}`);
};

export const getSalesContact = (lang, id) => {
  return api.get(`${lang}api/get/salesContact/${id}`);
};

export const getAllSalesContacts = (lang) => {
  return api.get(`${lang}api/get/allSalesContacts`);
};
